<template>
  <v-app style="background-color: #f8f9fb">
    <v-divider></v-divider>
    <br /><br />

    <!-- Diálogo de aviso: empresa sem telefone -->
    <v-dialog v-model="showNoPhoneDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline warning white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          Aviso
        </v-card-title>
        <v-card-text class="d-flex justify-center text-center pt-4">
          <div>
            <p class="mb-2">
              A empresa <strong>{{ empresaSemTelefone }}</strong> não possui
              telefones de WhatsApp cadastrados para busca de templates.
            </p>
            <p class="mb-0">Por favor, selecione outra empresa.</p>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="showNoPhoneDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="parametros-templates"
      fluid
      tag="section"
    >
      <!-- Card Superior: Configuração e Mapeamento de Parâmetros -->
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-tune"
            title="Configuração de Parâmetros de Templates"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <v-form ref="form" v-model="formValido" lazy-validation class="pt-2">
              <v-row align="center">
                <!-- Seleção de Empresa -->
                <v-col cols="12" sm="6" md="4">
                  <span class="font-weight-medium">Empresa</span>
                  <v-select
                    dense
                    solo-inverted
                    :items="empresasFiltradas"
                    v-model="empresaSelecionada"
                    filled
                    label="Selecione a empresa"
                    @change="onEmpresaChange"
                    :rules="[regras.obrigatorio]"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item v-if="telefonesDaEmpresaSelecionada.length > 0">
                        <v-list-item-content>
                          <v-list-item-title class="grey--text">
                            <small>
                              {{ telefonesDaEmpresaSelecionada.map(t => t.label + ': ' + t.numeroFormatado).join(' | ') }}
                            </small>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider v-if="telefonesDaEmpresaSelecionada.length > 0"></v-divider>
                    </template>
                  </v-select>
                </v-col>

                <!-- Informação do Template Selecionado (quando houver seleção via tabela) -->
                <v-col v-if="selectedTemplate" cols="12" sm="6" md="8">
                  <span class="font-weight-medium">Template em Edição</span>
                  <v-card
                    outlined
                    class="pa-2 d-flex align-center justify-space-between"
                    style="background: #f8fafc; border-color: #cbd5e1; height: 40px"
                  >
                    <div class="d-flex align-center text-truncate">
                      <v-icon small color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                      <span class="font-weight-bold text-body-2 text-truncate" style="color: #355C7D">
                        {{ selectedTemplate.name }}
                      </span>
                    </div>
                    <div class="d-flex align-center">
                      <v-chip
                        v-if="!podeEditar"
                        x-small
                        color="grey darken-1"
                        text-color="white"
                        class="mr-2"
                      >
                        <v-icon x-small left>mdi-eye</v-icon>
                        Modo Leitura
                      </v-chip>
                      <v-chip
                        v-if="selectedTemplate.tipoNumero"
                        x-small
                        :color="selectedTemplate.tipoNumero === 'Ativo' ? 'primary' : selectedTemplate.tipoNumero === 'Receptivo' ? 'teal' : 'deep-purple'"
                        text-color="white"
                        class="mr-2"
                      >
                        {{ selectedTemplate.tipoNumero }}
                      </v-chip>
                      <v-chip x-small color="success" text-color="white">
                        {{ extractTemplateParams(selectedTemplate.content).length }} params
                      </v-chip>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Alerta quando nenhum template estiver selecionado -->
              <v-row v-if="!selectedTemplate">
                <v-col cols="12">
                  <v-alert
                    type="info"
                    dense
                    text
                    class="mb-2"
                    icon="mdi-information-outline"
                  >
                    {{ empresaSelecionada
                      ? 'Selecione um template na tabela abaixo clicando no botão "Configurar" para editar seus parâmetros.'
                      : 'Selecione uma empresa acima para carregar a lista de templates disponíveis.' }}
                  </v-alert>
                </v-col>
              </v-row>

              <!-- Conteúdo do Template Selecionado -->
              <v-row v-if="selectedTemplate" class="mt-0">
                <v-col cols="12">
                  <v-card outlined class="pa-3" style="background-color: #f0f7ff; border-left: 4px solid #1976d2">
                    <div class="d-flex justify-space-between align-center mb-1">
                      <span class="text-subtitle-2 font-weight-bold text--primary">
                        <v-icon small color="primary" class="mr-1">mdi-message-text</v-icon>
                        Conteúdo do Template: <strong>{{ selectedTemplate.name }}</strong>
                        <span v-if="selectedTemplate.tipoNumero" class="grey--text text-caption ml-2">
                          ({{ selectedTemplate.tipoNumero }} - {{ selectedTemplate.numeroFormatado }})
                        </span>
                      </span>
                      <div>
                        <v-chip x-small color="primary" text-color="white" class="mr-1">
                          {{ parametrosAtivos.length }} parâmetro(s) detectado(s)
                        </v-chip>
                        <v-chip x-small color="success" text-color="white">
                          {{ selectedTemplate.status_broker || 'APPROVED' }}
                        </v-chip>
                      </div>
                    </div>
                    <div class="text-body-2" style="white-space: pre-wrap; line-height: 1.5; color: #1e293b">
                      {{ selectedTemplate.content }}
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-divider v-if="selectedTemplate" class="my-3"></v-divider>

              <!-- Cabeçalho da Seção de Parâmetros -->
              <div v-if="selectedTemplate" class="d-flex align-center justify-space-between mb-3">
                <div>
                  <span class="text-subtitle-1 font-weight-bold" style="color: #355C7D">
                    <v-icon left color="#355C7D">mdi-code-braces</v-icon>
                    Parâmetros do Template
                  </span>
                </div>
              </div>

              <!-- Grid dos Parâmetros (1 a 5) -->
              <v-row v-if="selectedTemplate">
                <v-col
                  v-for="num in parametrosAtivos"
                  :key="num"
                  cols="12"
                  md="6"
                  lg="4"
                >
                  <v-card
                    outlined
                    class="pa-3 h-100"
                    :style="isParametroPreenchido(num) ? 'border-top: 3px solid #4682B4; background: #fff' : 'background: #fafafa'"
                  >
                    <div class="d-flex justify-space-between align-center mb-2">
                      <span class="font-weight-bold text-caption" style="color: #4682B4">
                        <v-icon x-small color="#4682B4">mdi-variable</v-icon>
                        PARÂMETRO {{ formatParamTag(num) }}
                      </span>
                      <div>
                        <v-chip
                          v-if="isParametroDetectado(num)"
                          x-small
                          color="green lighten-4"
                          text-color="green darken-3"
                          class="mr-1"
                        >
                          Detectado
                        </v-chip>
                        <v-btn
                          v-if="podeEditar"
                          x-small
                          icon
                          color="error"
                          title="Limpar parâmetro"
                          @click="limparParametro(num)"
                        >
                          <v-icon x-small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Origem / Tipo de Variável Dinâmica -->
                    <span class="text-caption font-weight-medium">Origem do Valor</span>
                    <v-select
                      dense
                      solo-inverted
                      filled
                      :items="tiposValores"
                      v-model="parametrosForm['tipoParametro' + num]"
                      label="Tipo de Variável"
                      @change="(tipo) => onTipoParametroChange(num, tipo)"
                      hide-details
                      class="mb-2"
                      :disabled="!podeEditar"
                    >
                      <template v-slot:item="{ item }">
                        <v-icon small :color="item.cor" class="mr-2">{{ item.icone }}</v-icon>
                        {{ item.text }}
                      </template>
                    </v-select>

                    <!-- Rótulo / Label -->
                    <span class="text-caption font-weight-medium">Rótulo / Label de Exibição</span>
                    <v-text-field
                      dense
                      solo-inverted
                      filled
                      v-model="parametrosForm['labelParametro' + num]"
                      label="Ex.: Nome do Cliente"
                      placeholder="Ex.: Nome do Cliente"
                      hide-details
                      class="mb-2"
                      :readonly="!podeEditar"
                    ></v-text-field>

                    <!-- Identificador / Valor -->
                    <span class="text-caption font-weight-medium">Identificador / Valor</span>
                    <v-text-field
                      dense
                      solo-inverted
                      filled
                      v-model="parametrosForm['valorParametro' + num]"
                      :readonly="!podeEditar || parametrosForm['tipoParametro' + num] !== 'custom'"
                      label="Valor preenchido"
                      placeholder="Ex.: nome_cliente"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              :color="parametrosForm['tipoParametro' + num] !== 'custom' ? 'primary' : 'grey'"
                            >
                              {{ parametrosForm['tipoParametro' + num] !== 'custom' ? 'mdi-lock-outline' : 'mdi-pencil-outline' }}
                            </v-icon>
                          </template>
                          <span>{{ parametrosForm['tipoParametro' + num] !== 'custom' ? 'Preenchido automaticamente pelo preencherValorParametro' : 'Valor manual/fixo' }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Simulação do Template com Parâmetros Preenchidos -->
              <v-row v-if="selectedTemplate && temAlgumParametroPreenchido" class="mt-3">
                <v-col cols="12">
                  <v-card outlined class="pa-3" style="background-color: #f6ffed; border-left: 4px solid #52c41a">
                    <div class="d-flex align-center mb-1">
                      <v-icon small color="success" class="mr-1">mdi-eye-outline</v-icon>
                      <span class="text-subtitle-2 font-weight-bold text--primary">
                        Simulação de Preenchimento Automático (Preview):
                      </span>
                    </div>
                    <div class="text-body-2" style="white-space: pre-wrap; line-height: 1.5; color: #262626">
                      {{ previewTemplateTexto }}
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Ações do Formulário -->
              <v-card-actions v-if="selectedTemplate" class="d-flex justify-end pt-4 px-0">
                <v-btn
                  color="grey"
                  outlined
                  @click="limparFormulario"
                  class="mr-2"
                  :disabled="salvando"
                >
                  <v-icon left>mdi-close</v-icon> Cancelar
                </v-btn>
                <v-btn
                  v-if="podeEditar"
                  color="primary"
                  :loading="salvando"
                  :disabled="!podeSalvar"
                  @click="salvarParametros"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar Parâmetros
                </v-btn>
                <v-alert
                  v-else
                  type="info"
                  dense
                  text
                  class="mb-0 ml-2"
                >
                  Você possui permissão apenas para visualização de parâmetros.
                </v-alert>
              </v-card-actions>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>

      <!-- Card Inferior: Tabela de Templates da Empresa -->
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-format-list-bulleted-type"
            title="Templates da Empresa"
            color="rgb(71 130 180)"
            style="margin-top: 10px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <!-- Barra de Busca e Atualização -->
            <v-row align="center" class="pt-3 pb-1">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  solo-inverted
                  v-model="filtroBusca"
                  append-icon="mdi-magnify"
                  label="Buscar: Por nome ou conteúdo"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn
                  color="#4682B4"
                  outlined
                  small
                  :loading="loadingTemplates"
                  :disabled="!empresaSelecionada"
                  @click="carregarTemplates"
                >
                  Atualizar
                  <v-icon right small>mdi-refresh</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <!-- Tabela de Templates com Parâmetros -->
            <v-data-table
              :headers="tabelaHeaders"
              :items="templatesFiltrados"
              :search="filtroBusca"
              :loading="loadingTemplates"
              :items-per-page="15"
              class="elevation-0 mb-4"
              :no-data-text="empresaSelecionada ? 'Nenhum template com parâmetros encontrado para a empresa selecionada.' : 'Selecione uma empresa para listar os templates com parâmetros.'"
              no-results-text="Nenhum template encontrado para a busca."
              loading-text="Carregando templates..."
            >
              <!-- Nome do Template -->
              <template v-slot:item.name="{ item }">
                <div class="font-weight-bold" style="color: #355C7D">
                  {{ item.name }}
                </div>
              </template>

              <!-- Tipo / Número (Ativo ou Receptivo) -->
              <template v-slot:item.tipoNumero="{ item }">
                <v-chip
                  x-small
                  :color="item.tipoNumero === 'Ativo' ? 'primary' : item.tipoNumero === 'Receptivo' ? 'teal darken-1' : 'deep-purple'"
                  text-color="white"
                  class="font-weight-medium"
                >
                  <v-icon x-small left>
                    {{ item.tipoNumero === 'Ativo' ? 'mdi-phone-outgoing' : item.tipoNumero === 'Receptivo' ? 'mdi-phone-incoming' : 'mdi-phone' }}
                  </v-icon>
                  {{ item.tipoNumero }}
                </v-chip>
                <div class="text-caption text--secondary font-weight-light" v-if="item.numeroFormatado">
                  {{ item.numeroFormatado }}
                </div>
              </template>

              <!-- Conteúdo / Preview -->
              <template v-slot:item.content="{ item }">
                <div class="text-caption text-truncate" style="max-width: 360px">
                  {{ item.content }}
                </div>
              </template>

              <!-- Quantidade de Parâmetros -->
              <template v-slot:item.paramsCount="{ item }">
                <v-chip
                  small
                  :color="item.paramsCount > 0 ? 'primary' : 'grey lighten-1'"
                  text-color="white"
                >
                  {{ item.paramsCount }} parâmetro(s)
                </v-chip>
              </template>

              <!-- Status do Template -->
              <template v-slot:item.status="{ item }">
                <v-chip x-small color="success" text-color="white">
                  {{ item.status_cliente || 'ATIVO' }}
                </v-chip>
              </template>

              <!-- Ações -->
              <template v-slot:item.acoes="{ item }">
                <v-btn
                  @click="selecionarTemplateParaConfigurar(item)"
                  small
                  color="primary"
                  outlined
                  class="mr-2"
                >
                  <v-icon left small>mdi-cog</v-icon>
                  Configurar
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Snackbar de Feedback -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import SonaxService from "@/services/v2sonax";

export default {
  name: "Parametros",

  data() {
    return {
      formValido: false,
      salvando: false,
      loadingTemplates: false,
      filtroBusca: "",

      showNoPhoneDialog: false,
      empresaSemTelefone: "",

      empresas: [
        "A FLOR DO CAFÉ",
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
      ],
      empresaSelecionada: "",

      empresasTelefones: [
        {
          nome: "PREVIDA",
          aliases: ["PREVIDA"],
          telefones: [
            {
              label: "Ativo",
              numero: "558282308177",
              numeroFormatado: "(82) 8230-8177",
            },
            {
              label: "Receptivo",
              numero: "558000091700",
              numeroFormatado: "0800 009 1700",
            },
          ],
        },
        {
          nome: "MEMORIAL PARQUE MACEIO",
          aliases: ["MEMORIAL PARQUE MACEIO", "MEMORIAL PARQUE MACEIÓ"],
          telefones: [
            {
              label: "Ativo",
              numero: "558299289412",
              numeroFormatado: "(82) 9928-9412",
            },
            {
              label: "Receptivo",
              numero: "558291229510",
              numeroFormatado: "(82) 9122-9510",
            },
          ],
        },
        {
          nome: "PARQUE DAS FLORES",
          aliases: ["PARQUE DAS FLORES"],
          telefones: [
            {
              label: "Ativo",
              numero: "558296411028",
              numeroFormatado: "(82) 9641-1028",
            },
            {
              label: "Receptivo",
              numero: "558233389844",
              numeroFormatado: "(82) 3338-9844",
            },
          ],
        },
        {
          nome: "CEMITERIO PREVIDA",
          aliases: ["CEMITERIO PREVIDA"],
          telefones: [
            {
              label: "Principal",
              numero: "558000829000",
              numeroFormatado: "0800 082 9000",
            },
          ],
        },
        {
          nome: "CEMITERIO PREVIDA SAO MIGUEL",
          aliases: ["CEMITERIO PREVIDA SAO MIGUEL", "CEMITERIO PREVIDA SÃO MIGUEL"],
          telefones: [
            {
              label: "Principal",
              numero: "558000829000",
              numeroFormatado: "0800 082 9000",
            },
          ],
        },
        {
          nome: "PARQUE DO AGRESTE",
          aliases: ["PARQUE DO AGRESTE"],
          telefones: [
            {
              label: "Principal",
              numero: "558000829000",
              numeroFormatado: "0800 082 9000",
            },
          ],
        },
        {
          nome: "A FLOR DO CAFE",
          aliases: ["A FLOR DO CAFE", "A FLOR DO CAFÉ"],
          telefones: [
            {
              label: "Principal",
              numero: "558000829000",
              numeroFormatado: "0800 082 9000",
            },
          ],
        },
      ],

      templates: [],
      selectedTemplate: null,
      parametrosDetectados: [],

      tiposValores: [
        { text: "Nome do Cliente (Curto)", value: "nome_cliente", icone: "mdi-account", cor: "primary" },
        { text: "Nome Completo do Cliente", value: "nome_completo_cliente", icone: "mdi-account-box", cor: "indigo" },
        { text: "CPF do Cliente", value: "cpf_cliente", icone: "mdi-card-account-details", cor: "blue darken-2" },
        { text: "Telefone do Cliente", value: "telefone_cliente", icone: "mdi-phone", cor: "teal" },
        { text: "Nome do Atendente (Logado)", value: "nome_user", icone: "mdi-account-tie", cor: "deep-purple" },
        { text: "Saudação (Bom dia/Boa tarde/noite)", value: "saudacao", icone: "mdi-weather-sunny", cor: "amber darken-2" },
        { text: "DataAtual (dd/MM/yyyy)", value: "data_atual", icone: "mdi-calendar", cor: "green" },
        { text: "HoraAtual (HH:mm)", value: "hora_atual", icone: "mdi-clock-outline", cor: "cyan" },
        { text: "Texto Fixo / Personalizado", value: "custom", icone: "mdi-pencil", cor: "grey darken-1" },
        { text: "Não Utilizado", value: "none", icone: "mdi-close", cor: "grey lighten-1" },
      ],

      parametrosForm: {
        tipoParametro1: "none",
        labelParametro1: "",
        valorParametro1: "",

        tipoParametro2: "none",
        labelParametro2: "",
        valorParametro2: "",

        tipoParametro3: "none",
        labelParametro3: "",
        valorParametro3: "",

        tipoParametro4: "none",
        labelParametro4: "",
        valorParametro4: "",

        tipoParametro5: "none",
        labelParametro5: "",
        valorParametro5: "",
      },

      tabelaHeaders: [
        { text: "Nome do Template", value: "name", sortable: true },
        { text: "Tipo / Número", value: "tipoNumero", sortable: true, width: "170px" },
        { text: "Conteúdo", value: "content", sortable: true },
        { text: "Qtd. Parâmetros", value: "paramsCount", sortable: true, align: "center", width: "140px" },
        { text: "Status", value: "status", sortable: false, width: "100px" },
        { text: "Ações", value: "acoes", sortable: false, width: "130px", align: "center" },
      ],

      regras: {
        obrigatorio: (v) => !!v || "Este campo é obrigatório",
      },

      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3500,
      },
    };
  },

  created() {
    if (this.$store?.state?.auth?.status?.loggedIn === false) {
      this.$router.push("/login");
      return;
    }
    if (!this.podeAcessar) {
      this.$router.push("restrito");
    }
  },

  mounted() {
    // Não carrega empresa automaticamente; aguarda seleção do usuário
  },

  computed: {
    user() {
      try {
        return (
          this.$store?.state?.auth?.user ||
          JSON.parse(sessionStorage.getItem("user")) ||
          {}
        );
      } catch (e) {
        return {};
      }
    },

    roles() {
      return Array.isArray(this.user?.roles) ? this.user.roles : [];
    },

    isAdmin() {
      return this.roles.includes("ROLE_ADMIN");
    },

    podeAcessar() {
      return (
        this.isAdmin ||
        this.roles.includes("ROLE_PARAMETROS") ||
        this.roles.includes("ROLE_PARAMETROS_CONSULTA") ||
        this.roles.includes("ROLE_PARAMETROS_CADASTRO") ||
        this.roles.includes("ROLE_TEMPLATES")
      );
    },

    podeEditar() {
      return (
        this.isAdmin ||
        this.roles.includes("ROLE_PARAMETROS") ||
        this.roles.includes("ROLE_PARAMETROS_CADASTRO")
      );
    },

    empresasFiltradas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },

    telefonesDaEmpresaSelecionada() {
      if (!this.empresaSelecionada) return [];
      return this.obterTelefonesEmpresa(this.empresaSelecionada);
    },

    templatesFiltrados() {
      if (!this.empresaSelecionada || !this.templates || !this.templates.length) return [];

      return this.templates
        .filter(
          (template) =>
            template.status_cliente === "ATIVO" &&
            template.status_broker === "APPROVED" &&
            this.extractTemplateParams(template.content).length > 0
        )
        .map((template) => ({
          ...template,
          paramsCount: this.extractTemplateParams(template.content).length,
        }));
    },

    parametrosAtivos() {
      const set = new Set();

      if (this.parametrosDetectados && this.parametrosDetectados.length > 0) {
        this.parametrosDetectados.forEach((p) => set.add(p));
      }

      for (let i = 1; i <= 5; i++) {
        if (this.isParametroPreenchido(i)) {
          set.add(i);
        }
      }

      if (set.size === 0) {
        set.add(1);
        set.add(2);
      }

      return Array.from(set).sort((a, b) => a - b);
    },

    podeSalvar() {
      return (
        this.podeEditar &&
        !!this.selectedTemplate &&
        this.temAlgumParametroPreenchido &&
        !this.salvando
      );
    },

    temAlgumParametroPreenchido() {
      for (let i = 1; i <= 5; i++) {
        const valor = this.parametrosForm["valorParametro" + i];
        if (valor && String(valor).trim() !== "") {
          return true;
        }
      }
      return false;
    },

    previewTemplateTexto() {
      if (!this.selectedTemplate || !this.selectedTemplate.content) return "";
      let texto = this.selectedTemplate.content;

      for (let i = 1; i <= 5; i++) {
        const valor = this.parametrosForm["valorParametro" + i];
        let valorSubstituido = `{{${i}}}`;

        if (valor === "nome_cliente") {
          valorSubstituido = "[João Silva (Cliente)]";
        } else if (valor === "nome_completo_cliente") {
          valorSubstituido = "[João da Silva Pereira]";
        } else if (valor === "cpf_cliente") {
          valorSubstituido = "[112.***.***-80]";
        } else if (valor === "telefone_cliente") {
          valorSubstituido = "[82999998888]";
        } else if (valor === "nome_user") {
          valorSubstituido = "[Maria Santos (Atendente)]";
        } else if (valor === "saudacao") {
          valorSubstituido = "[Olá / Bom dia]";
        } else if (valor === "data_atual") {
          valorSubstituido = "[20/08/2026]";
        } else if (valor === "hora_atual") {
          valorSubstituido = "[14:30]";
        } else if (valor && String(valor).trim() !== "") {
          valorSubstituido = `[${valor}]`;
        }

        const regex = new RegExp(`\\{\\{${i}\\}\\}`, "g");
        texto = texto.replace(regex, valorSubstituido);
      }

      return texto;
    },
  },

  methods: {
    hasPermission(empresa) {
      if (!this.user || !this.user.roles) return false;

      const roles = this.roles;

      if (this.isAdmin) {
        return true;
      }

      if (empresa === "Todas") {
        return true;
      }

      const normalizar = (str) =>
        str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .trim()
          .replace(/\s+/g, "_");

      const roleComAcento = "ROLE_" + empresa.trim().toUpperCase().replace(/\s+/g, "_");
      const roleSemAcento = "ROLE_" + normalizar(empresa);

      // Mapeamento explícito de papéis para cada empresa
      const mapRoles = {
        PREVIDA: ["ROLE_PREVIDA"],
        "MEMORIAL PARQUE MACEIÓ": ["ROLE_MEMORIAL_PARQUE_MACEIÓ", "ROLE_MEMORIAL_PARQUE_MACEIO", "ROLE_MEMORIAL"],
        "PARQUE DAS FLORES": ["ROLE_PARQUE_DAS_FLORES", "ROLE_PARQUE"],
        "PARQUE DO AGRESTE": ["ROLE_PARQUE_DO_AGRESTE"],
        "CEMITERIO PREVIDA": ["ROLE_CEMITERIO_PREVIDA"],
        "CEMITERIO PREVIDA SÃO MIGUEL": ["ROLE_CEMITERIO_PREVIDA_SÃO_MIGUEL", "ROLE_CEMITERIO_PREVIDA_SAO_MIGUEL"],
        "A FLOR DO CAFÉ": ["ROLE_A_FLOR_DO_CAFÉ", "ROLE_A_FLOR_DO_CAFE", "ROLE_MELRO_SAMPAIO"],
      };

      const customRoles = mapRoles[empresa] || [];
      const todasPossiveis = [roleComAcento, roleSemAcento, ...customRoles];

      return todasPossiveis.some((r) => roles.includes(r));
    },

    formatParamTag(num) {
      return `{{${num}}}`;
    },

    mostrarMensagem(texto, cor = "info") {
      this.snackbar.text = texto;
      this.snackbar.color = cor;
      this.snackbar.show = true;
    },

    limparParametro(num) {
      this.parametrosForm["tipoParametro" + num] = "none";
      this.parametrosForm["labelParametro" + num] = "";
      this.parametrosForm["valorParametro" + num] = "";
    },

    extractTemplateParams(content) {
      if (!content) return [];
      const regex = /\{\{(\d+)\}\}/g;
      const params = [];
      let match;
      while ((match = regex.exec(content)) !== null) {
        params.push(parseInt(match[1]));
      }
      return [...new Set(params)].sort((a, b) => a - b);
    },

    isParametroDetectado(num) {
      return this.parametrosDetectados.includes(num);
    },

    isParametroPreenchido(num) {
      const v = this.parametrosForm["valorParametro" + num];
      return v && String(v).trim() !== "";
    },

    normalizarNomeEmpresa(empresa) {
      return String(empresa || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();
    },

    obterConfigTelefonesEmpresa(empresa) {
      const empresaNormalizada = this.normalizarNomeEmpresa(empresa);

      const configExata = this.empresasTelefones.find((config) => {
        const nomes = [config.nome, ...(config.aliases || [])];
        return nomes.some(
          (nome) => this.normalizarNomeEmpresa(nome) === empresaNormalizada
        );
      });

      if (configExata) {
        return configExata;
      }

      if (empresaNormalizada.includes("CEMITERIO") && empresaNormalizada.includes("MIGUEL")) {
        return this.empresasTelefones.find((c) => c.nome === "CEMITERIO PREVIDA SAO MIGUEL") || null;
      }
      if (empresaNormalizada.includes("CEMITERIO")) {
        return this.empresasTelefones.find((c) => c.nome === "CEMITERIO PREVIDA") || null;
      }
      if (empresaNormalizada.includes("PARQUE") && empresaNormalizada.includes("AGRESTE")) {
        return this.empresasTelefones.find((c) => c.nome === "PARQUE DO AGRESTE") || null;
      }
      if (empresaNormalizada.includes("PARQUE") && empresaNormalizada.includes("FLORES")) {
        return this.empresasTelefones.find((c) => c.nome === "PARQUE DAS FLORES") || null;
      }
      if (empresaNormalizada.includes("MEMORIAL")) {
        return this.empresasTelefones.find((c) => c.nome === "MEMORIAL PARQUE MACEIO") || null;
      }
      if (empresaNormalizada.includes("PREVIDA")) {
        return this.empresasTelefones.find((c) => c.nome === "PREVIDA") || null;
      }
      if (empresaNormalizada.includes("FLOR") || empresaNormalizada.includes("CAF")) {
        return this.empresasTelefones.find((c) => c.nome === "A FLOR DO CAFE") || null;
      }

      return null;
    },

    obterTelefonesEmpresa(empresa) {
      const config = this.obterConfigTelefonesEmpresa(empresa);
      return config ? [...config.telefones] : [];
    },

    onEmpresaChange() {
      this.limparFormulario();

      if (!this.empresaSelecionada) {
        this.templates = [];
        return;
      }

      this.carregarTemplates();
    },

    async carregarTemplates() {
      if (!this.empresaSelecionada) {
        this.templates = [];
        return;
      }

      const telefones = this.obterTelefonesEmpresa(this.empresaSelecionada);
      if (!telefones || telefones.length === 0) {
        this.empresaSemTelefone = this.empresaSelecionada;
        this.templates = [];
        this.showNoPhoneDialog = true;
        this.$nextTick(() => {
          this.empresaSelecionada = "";
        });
        return;
      }

      this.loadingTemplates = true;
      try {
        const templatesCarregados = [];

        // Buscar templates para cada telefone da empresa (Ativo, Receptivo, etc.)
        const promessas = telefones.map(async (telefoneConfig) => {
          try {
            const response = await SonaxService.getTemplates(telefoneConfig.numero);
            if (
              response.data &&
              !response.data.error &&
              response.data.data &&
              response.data.data.brokers &&
              response.data.data.brokers.length > 0
            ) {
              let brokerEncontrado = response.data.data.brokers.find(
                (broker) => broker.number === telefoneConfig.numero
              );

              if (
                !brokerEncontrado ||
                !brokerEncontrado.templates ||
                brokerEncontrado.templates.length === 0
              ) {
                brokerEncontrado = response.data.data.brokers.find(
                  (broker) => broker.templates && broker.templates.length > 0
                );
              }

              if (brokerEncontrado && brokerEncontrado.templates) {
                brokerEncontrado.templates.forEach((template) => {
                  templatesCarregados.push({
                    ...template,
                    brokerNumber: brokerEncontrado.number,
                    telefoneEmpresa: telefoneConfig.numero,
                    tipoNumero: telefoneConfig.label, // "Ativo", "Receptivo", etc.
                    numeroFormatado: telefoneConfig.numeroFormatado,
                  });
                });
              }
            }
          } catch (err) {
            console.warn(`Erro ao carregar templates para o telefone ${telefoneConfig.numero}:`, err);
          }
        });

        await Promise.all(promessas);

        this.templates = templatesCarregados;
        this.mostrarMensagem(
          `${this.templatesFiltrados.length} templates com parâmetros encontrados.`,
          "info"
        );
      } catch (error) {
        console.error("Erro ao carregar templates:", error);
        this.mostrarMensagem(
          error.response?.data?.message || "Erro ao carregar templates da empresa.",
          "error"
        );
        this.templates = [];
      } finally {
        this.loadingTemplates = false;
      }
    },

    selecionarTemplateParaConfigurar(template) {
      this.selectedTemplate = template;
      this.parametrosDetectados = this.extractTemplateParams(template.content);
      this.resetParametrosForm();

      this.consultarParametrosDoTemplate(template.name);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async consultarParametrosDoTemplate(templateNome) {
      if (!templateNome) return;

      try {
        const resp = await SonaxService.preencherParametros(templateNome);
        if (resp.data && Array.isArray(resp.data) && resp.data.length > 0) {
          resp.data.forEach((item) => {
            const num = item.numeroParametro;
            if (num >= 1 && num <= 5) {
              const valor = item.valor || "";
              const label = item.label || "";

              let tipo = "none";
              if (
                [
                  "nome_cliente",
                  "nome_completo_cliente",
                  "cpf_cliente",
                  "telefone_cliente",
                  "nome_user",
                  "saudacao",
                  "data_atual",
                  "hora_atual",
                ].includes(valor)
              ) {
                tipo = valor;
              } else if (valor && valor.trim() !== "") {
                tipo = "custom";
              }

              this.parametrosForm["tipoParametro" + num] = tipo;
              this.parametrosForm["labelParametro" + num] = label;
              this.parametrosForm["valorParametro" + num] = valor;
            }
          });
          this.mostrarMensagem(`Parâmetros carregados para "${templateNome}".`, "info");
        } else {
          this.sugerirParametrosAutomaticamente();
        }
      } catch (error) {
        this.sugerirParametrosAutomaticamente();
      }
    },

    sugerirParametrosAutomaticamente() {
      const texto = this.selectedTemplate ? (this.selectedTemplate.content || "").toLowerCase() : "";
      const params = this.parametrosDetectados.length > 0 ? this.parametrosDetectados : [1, 2];

      if (params.includes(1)) {
        this.parametrosForm.tipoParametro1 = "nome_cliente";
        this.parametrosForm.labelParametro1 = "Nome do Cliente";
        this.parametrosForm.valorParametro1 = "nome_cliente";
      }

      if (params.includes(2)) {
        if (
          texto.includes("me chamo {{2}}") ||
          texto.includes("atendente {{2}}") ||
          texto.includes("sou {{2}}") ||
          params.length === 2
        ) {
          this.parametrosForm.tipoParametro2 = "nome_user";
          this.parametrosForm.labelParametro2 = "Atendente";
          this.parametrosForm.valorParametro2 = "nome_user";
        } else {
          this.parametrosForm.tipoParametro2 = "custom";
          this.parametrosForm.labelParametro2 = "Parâmetro 2";
          this.parametrosForm.valorParametro2 = "";
        }
      }

      for (let i = 3; i <= 5; i++) {
        if (params.includes(i)) {
          this.parametrosForm["tipoParametro" + i] = "custom";
          this.parametrosForm["labelParametro" + i] = `Parâmetro ${i}`;
          this.parametrosForm["valorParametro" + i] = "";
        }
      }
    },

    onTipoParametroChange(num, tipo) {
      const mapSugestoes = {
        nome_cliente: { label: "Nome do Cliente", valor: "nome_cliente" },
        nome_completo_cliente: { label: "Nome Completo", valor: "nome_completo_cliente" },
        cpf_cliente: { label: "CPF do Cliente", valor: "cpf_cliente" },
        telefone_cliente: { label: "Telefone do Cliente", valor: "telefone_cliente" },
        nome_user: { label: "Atendente", valor: "nome_user" },
        saudacao: { label: "Saudação", valor: "saudacao" },
        data_atual: { label: "Data Atual", valor: "data_atual" },
        hora_atual: { label: "Hora Atual", valor: "hora_atual" },
        none: { label: "", valor: "" },
      };

      if (mapSugestoes[tipo]) {
        this.parametrosForm["labelParametro" + num] = mapSugestoes[tipo].label;
        this.parametrosForm["valorParametro" + num] = mapSugestoes[tipo].valor;
      } else if (tipo === "custom") {
        if (
          Object.keys(mapSugestoes).includes(this.parametrosForm["valorParametro" + num])
        ) {
          this.parametrosForm["valorParametro" + num] = "";
        }
        if (!this.parametrosForm["labelParametro" + num]) {
          this.parametrosForm["labelParametro" + num] = `Parâmetro ${num}`;
        }
      }
    },

    resetParametrosForm() {
      for (let i = 1; i <= 5; i++) {
        this.parametrosForm["tipoParametro" + i] = "none";
        this.parametrosForm["labelParametro" + i] = "";
        this.parametrosForm["valorParametro" + i] = "";
      }
    },

    limparFormulario() {
      this.selectedTemplate = null;
      this.parametrosDetectados = [];
      for (let i = 1; i <= 5; i++) {
        this.parametrosForm["tipoParametro" + i] = "none";
        this.parametrosForm["labelParametro" + i] = "";
        this.parametrosForm["valorParametro" + i] = "";
      }

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    async salvarParametros() {
      if (!this.podeEditar) {
        this.mostrarMensagem("Você não tem permissão para alterar parâmetros.", "error");
        return;
      }

      if (!this.$refs.form || !this.$refs.form.validate() || !this.selectedTemplate) {
        return;
      }

      this.salvando = true;

      const payload = {
        templateNome: this.selectedTemplate.name,
        labelParametro1: this.parametrosForm.labelParametro1 || null,
        valorParametro1: this.parametrosForm.valorParametro1 || null,
        labelParametro2: this.parametrosForm.labelParametro2 || null,
        valorParametro2: this.parametrosForm.valorParametro2 || null,
        labelParametro3: this.parametrosForm.labelParametro3 || null,
        valorParametro3: this.parametrosForm.valorParametro3 || null,
        labelParametro4: this.parametrosForm.labelParametro4 || null,
        valorParametro4: this.parametrosForm.valorParametro4 || null,
        labelParametro5: this.parametrosForm.labelParametro5 || null,
        valorParametro5: this.parametrosForm.valorParametro5 || null,
      };

      try {
        await SonaxService.salvarTemplateParametros(payload);
        this.mostrarMensagem("Parâmetros do template salvos com sucesso!", "success");
      } catch (error) {
        console.error("Erro ao salvar parâmetros:", error);
        const msg = error.response?.data?.error || "Erro ao salvar parâmetros do template.";
        this.mostrarMensagem(msg, "error");
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
</style>
